import {
  ROOT,
  GET_GENERAL_SETTING,
  UPDATE_GENERAL_SETTING,
  LANGUAGE_ALL
} from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function get() {
  return fetch(ROOT + GET_GENERAL_SETTING, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(data) {
  return fetch(ROOT + UPDATE_GENERAL_SETTING, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getLangs() {
  return fetch(ROOT + LANGUAGE_ALL, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

export const service = {
  get,
  update,
  getLangs
};
